import React from 'react';
import {useState, useEffect, useRef} from "react";
import { Link } from 'react-router-dom';
import './Distributors.css';
import useAxiosPrivate from "../../context/useAxiosPrivate";
import {DataTable} from "../data-table/DataTable";
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import { Select, MenuItem } from '@mui/material'
import {useAuth} from "../../context/useAuth";
import { baseUrl } from "../../api/axios";
import '../data-table/DataTable.css';


export const Distributors = ({userRole}) => {
  const { auth, setAuth } = useAuth();
  const [version, setVersion] = useState(null);
  const [factories, setFactories] = useState(null);
  const refFactories = useRef({previousFactoriesLength: 0, currentFactoriesLength: 0})
  const [companies, setCompanies] = useState(null);
  const [usersByFactoryId, setUsersByFactoryId] = useState([]);
  const [currentFactory, setCurrentFactory] = useState('');
  const [currentFactoryData, setCurrentFactoryData] = useState(null)
  const [modalType, setModalType] = useState('');
  const axiosPrivate = useAxiosPrivate();

  const [factoriesSelectOptions, setFactoriesSelectOptions] = useState('');

  useEffect(() => {
    if (userRole.roleId === 1) {
      getFactories();
      getCompanies();
      // getVersion();
    } else {
      getCompanies();
      setCurrentFactory(userRole.id);
      // getVersion();
    }
  },[]);


  useEffect(() => {
    if (currentFactory !== '') {
      getUsersByFactoryId();
      if (userRole.roleId === 1) {
        getCurrentFactoryData();
        localStorage.setItem('chosenFactory', currentFactory);
        getVersion(currentFactory);
      }
    }
  }, [currentFactory]);


  const getVersion = async (factoryId) => {
    await axiosPrivate.get(`Users/Version/${factoryId}`)
      .then((res) => {
        setVersion(res.data)
      })
      .catch( (e) => { console.log("getVersion error ", e) } );
  }

  const getFactories = async () => {
    await axiosPrivate.get('/Users/Factory')
      .then((res) => {
        setFactories(res.data);
        refFactories.current.currentFactoriesLength = res.data.length;
      })
      .catch( (e) => { console.log("getFactories error ", e) } );
  }


  const getCompanies = async () => {
    await axiosPrivate.get('/Users/Company')
      .then((res) => {
        setCompanies(res.data);
      })
      .catch( (e) => { console.log("getCompanies error ", e) } );
  }

  const getUsersByFactoryId = async () => {
    await axiosPrivate.get(`/Users/GetByFactory/${currentFactory}`)
      .then((res) => {
        setUsersByFactoryId(res.data)
      })
      .catch( (e) => { console.log("getUsersByFactoryId error ", e) } );
  }


  useEffect(() => {
    if (factories !== null) {
      getFactoriesSelectOptions()
    }

  }, [factories]);

  const getCurrentFactoryData = () => {
    setCurrentFactoryData(factories.filter((factory) => {
      return factory.id === parseInt(currentFactory)
    }))
  }

  const getFactoriesSelectOptions = () => {
    const optionData = factories.map((factory) => {
      return <MenuItem key={factory.id} value={factory.id}>{`${factory.factory}`}</MenuItem>
    })
    setFactoriesSelectOptions(optionData); // form list of factories in dropdown menu

    const savedFactoryId = JSON.parse(localStorage.getItem('chosenFactory'))
    const savedIdIsExist = factories.some((item) => {
      return item.id === savedFactoryId
    })


    if (userRole.roleId === 1 && JSON.parse(localStorage.getItem('chosenFactory')) === null) {
      setCurrentFactory(factories[0].id)
    }

    if (savedIdIsExist && userRole.roleId === 1 && JSON.parse(localStorage.getItem('chosenFactory')) !== null) {
      setCurrentFactory(JSON.parse(localStorage.getItem('chosenFactory')));
    } else {
      setCurrentFactory(factories[0].id)
    }
    // if (currentFactory === '') {
    //   setCurrentFactory('2')
    // }

    userRole.roleId === 1 && getCurrentFactoryData();
  }




  return (
    <div className="distributors-container">
      <div className="distributors-controls">
        <ul className="distributors-controls__list">
          <li className="distributors-controls__item">
            <div className={userRole.roleId === 1 ? "distributors-factories" : "hidden"}>
              <label className="distributors-button-label">
                Активность заводов
                <button
                  className="factory-button"
                  onClick={() => setModalType("factoryActivity")}
                ></button>
              </label>


              <div className="distributors-factories-controls">
                <div className="select-container">
                  {userRole.roleId === 1 && <Select
                    IconComponent={ExpandMoreOutlinedIcon}
                    style={{backgroundColor: "white"}}
                    MenuProps={{
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left"
                      },
                      PaperProps: {
                        sx: {
                          '& .MuiMenuItem-root': {fontSize: "1.5vw"}
                        }
                      }
                    }}
                    sx={{
                      '& .MuiInputBase-root': {borderRadius: "8px", border: "0.2vw solid grey", outline: "none"},
                      '& .MuiSelect-select': {
                        backgroundColor: "white",
                        border: "none",
                        width: "100%",
                        fontSize: "1.5vw",
                        minHeight: "2vw",
                        lineHeight: "1",
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        overflow: "hidden",
                      },
                      '& .MuiInputBase-input': {padding: "0 3vw 0 0.5vw !important"},
                      '& .MuiSvgIcon-root': {position: "absolute", top: "calc(50% - 1.5vw)", right: "0", display: "flex", justifyContent: "center", alignItems: "center", fontSize: "3vw", backgroundColor: "transparent"},

                    }}
                    variant={"outlined"}
                    autoWidth={true}
                    value={currentFactory}
                    onChange={(event) => {
                      setCurrentFactory(event.target.value);
                    }
                    }
                  >
                    {factoriesSelectOptions}
                  </Select>}
                </div>


                <button className="distributors-button distributors-button__add distributors-button__add_factory"
                        onClick={() => setModalType('addFactory')}
                >+</button>

                <button className="distributors-button distributors-button__add distributors-button__edit"
                        onClick={() => setModalType('editFactory')}
                ></button>
              </div>

            </div>
          </li>


          <li className="distributors-controls__item">

          </li>

          {userRole.roleId === 1 && version && <li className="distributors-controls__item">
            <a className="distributors-version platform platform__android platform_position" target="_blank" href={`${version.linkAndroid}`}></a>

            <a className="distributors-version platform platform__ios platform_position" target="_blank" href={`${version.linkIOS}`}></a>

            <a className="distributors-version platform platform__macos platform_position" target="_blank" href={`${version.linkMacOS}`}></a>
          </li>}

          {userRole.roleId === 1 && version && <li className="distributors-controls__item">
               <a className="distributors-version" download={`${version.factoryName}`} href={`${baseUrl}${version.link}`}>{version.version}</a>
          </li>}

          <li className="distributors-controls__item">
            <button className="distributors-button__logout" onClick={() => {
              localStorage.setItem('currentVisitorFAPP', null)
              setAuth(null)
            }}></button>
          </li>
        </ul>

        <div className="distributors-edit-container">
          <div className={userRole.roleId === 1 ? "distributors-edit" : "hidden"}>
            <label className="distributors-button-label">Добавить компанию
              <button id="add-company" className="distributors-button distributors-button__add"
              onClick={() => setModalType('addCompany')}
              >+</button>
            </label>

            <label
              style={usersByFactoryId.length === 0 ? {display: "none"} : {}}
              className="distributors-button-label">Добавить компьютер в имеющуюся компанию
              <button
                disabled={(usersByFactoryId.length === 0) && true}
                className="distributors-button distributors-button__add"
              onClick={() => setModalType('addUser')}
              >+</button>
            </label>
          </div>

          <label className="distributors-button-label">
            Отправить уведомление
            <button
              className="send-notification-button"
              onClick={() => setModalType("factoryNotify")}
            ></button>
          </label>

          {userRole.roleId === 1 && <label className="distributors-button-label">
            Конфигуратор
            <Link to="/add-json">
              <button className="settings-button"></button>
            </Link>
          </label>
          }
        </div>
      </div>

      <DataTable
        getFactories={getFactories}
        factories={factories}
        currentFactoryData={currentFactoryData}
        usersByFactoryId={usersByFactoryId}
        setUsersByFactoryId={setUsersByFactoryId}
        getUsersByFactoryId={getUsersByFactoryId}
        getCompanies={getCompanies}
        userRole={userRole}
        modalType={modalType}
        setModalType={setModalType}
        companies={companies}
        currentFactory={currentFactory}
        setCurrentFactory={setCurrentFactory}
      />
    </div>
  )
}